module.exports = __webpack_public_path__ + "img/eye-close.f56a11db.png";